import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); }`;

const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 4rem 2rem;
  background-color: #f8f9fa;
  box-sizing: border-box;
`;

export const FormWrapper = styled.form`
  width: 100%;
  max-width: 800px;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  animation: ${fadeIn} 0.6s ease-out;
  box-sizing: border-box;
  position: relative;
`;

export const BackButton = styled.button`
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  background: none;
  border: none;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease;
  &:hover {
    color: #007bff;
  }
`;

export const Header = styled.header`
  text-align: center;
  margin-bottom: 2.5rem;
  h1 {
    color: #212529;
    font-size: 2rem;
    margin: 1rem 0 0.5rem 0;
  }
  p {
    color: #6c757d;
    font-size: 1rem;
    margin: 0;
  }
`;

export const Logo = styled.img`
  width: 80px;
`;

export const Section = styled.section`
  margin-bottom: 2.5rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.25rem;
  color: #343a40;
  margin: 0 0 1.5rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e9ecef;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
  label {
    font-size: 0.875rem;
    color: #495057;
    font-weight: 500;
  }
  input,
  select {
    width: 100%;
    height: 48px;
    border: 1px solid #ced4da;
    background: #f8f9fa;
    padding: 0 1rem;
    color: #495057;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.2s ease;
    box-sizing: border-box;
    &:focus {
      outline: none;
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }

  input[readOnly] {
    background-color: #e9ecef;
    cursor: not-allowed;
    color: #6c757d;
  }

  input[readOnly]:focus {
    box-shadow: none;
    border-color: #ced4da;
  }
`;

// --- NOVOS ESTILOS PARA A SENHA E BOTÃO DE OLHO ---

export const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;

  input {
    padding-right: 2.5rem; /* Espaço para o botão do olho */
  }
`;

export const EyeButton = styled.button`
  position: absolute;
  right: 0.8rem;
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: color 0.2s;
  &:hover {
    color: #007bff;
  }
`;

// ---------------------------------------------------

export const DocTypeSelector = styled.div`
  display: flex;
  border: 1px solid #ced4da;
  border-radius: 8px;
  overflow: hidden;
`;

export const DocTypeButton = styled.button`
  flex-grow: 1;
  padding: 0.75rem;
  background-color: ${(props) => (props.active ? "#007bff" : "#ffffff")};
  color: ${(props) => (props.active ? "#ffffff" : "#495057")};
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  &:not(:last-child) {
    border-right: 1px solid #ced4da;
  }
  &:hover {
    background-color: ${(props) => (props.active ? "#0069d9" : "#e9ecef")};
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  height: 50px;
  background: linear-gradient(45deg, #28a745, #218838);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3);
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background: #6c757d;
    box-shadow: none;
  }
`;

export const UsernameInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const StatusIndicator = styled.div`
  position: absolute;
  right: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  font-weight: 500;

  color: ${({ status }) => {
    if (status === "valid" || status === "available") return "#28a745";
    if (status === "invalid" || status === "taken" || status === "error")
      return "#dc3545";
    return "#6c757d";
  }};

  .spinner {
    animation: ${spin} 1s linear infinite;
  }
`;

export const ErrorMessage = styled.p`
  color: #dc3545;
  font-size: 0.8rem;
  margin: 0.25rem 0 0 0;
  padding-left: 0.25rem;
`;

export const InfoMessage = styled.p`
  color: #6c757d;
  font-size: 0.8rem;
  margin: -0.25rem 0 0.5rem 0;
  padding-left: 0.25rem;
  font-style: italic;
`;
